import styled from "styled-components";

export const RefrentInfo = styled.div`
  justify-self: auto;
  color: ${(props) => props.color ?? "#4d4d4d"};
  font-size: ${(props) => props.size ?? "12px"};
  font-weight: ${(props) => props.weight ?? "400"};
  padding-left: 20px;
  padding-right: 1.375rem;
  line-height: ${(props) => props.lineHeight ?? "16px"};
`;

export const SubsituteInfo = styled.div`
  justify-self: auto;
  color: #767676;
  font-size: 14px;
  font-weight: 400;
  padding-left: 20px;
  padding-right: 1.375rem;
`;

export const GridRowNoGap = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  font-weight: normal;
}
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  margin: 20px;
`;
